import { useStyletron } from "baseui";
import { Block } from "baseui/block";
import { HeadingMedium, LabelSmall, ParagraphMedium, ParagraphXSmall } from "baseui/typography";
import { useMemo, useState } from "react";
import { VscPerson, VscUnlock } from "react-icons/vsc";
import { LoadingView } from "../../components/LoadingView";
import { useGetUserQuery, useGetUsersAppRolesQuery } from "../../services/users/userApi";
import { Button } from "baseui/button";
import { ListItem, ListItemLabel } from "baseui/list";
import { Tabs, Tab } from "baseui/tabs-motion";
import { TAppRoleDto } from "../../services/resourceGroups/types";
import UpdateRolesDialog from "./updateRolesDialog/UpdateRolesDialog";
import { Badge } from "baseui/badge";
import { HorizontalStackPanel } from "../../components/Layout/StackPanel";

const UserView = (props: { userId: string; subscriptionId: string }) => {
  const { userId } = props;
  const [css, theme] = useStyletron();
  const {
    data: user,
    isLoading,
    isSuccess,

    error,
  } = useGetUserQuery(userId);
  const [activeKey, setActiveKey] = useState<any>(0);

  const disabled = user?.accountEnabled !== undefined && user.accountEnabled !== null ? !user.accountEnabled : false;
  const isNotActive = user?.pendingInvitation;
  return (
    <Block width="100%" className={css({ position: "relative" })}>
      <LabelSmall color={theme.colors.accent}>User</LabelSmall>
      <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
        <HeadingMedium margin={0}>
          <VscPerson color={theme.colors.primary} /> {user?.name || ""}
        </HeadingMedium>
        <ParagraphXSmall>{userId}</ParagraphXSmall>
        <ParagraphMedium>{user?.mail}</ParagraphMedium>
        {disabled && <Badge content={"Account disabled"} hierarchy="secondary" color="negative" />}
        {isNotActive && (
          <HorizontalStackPanel>
            {" "}
            <ParagraphXSmall margin={0}>{"Invitation Status"}</ParagraphXSmall>{" "}
            <Badge
              hierarchy={"secondary"}
              color={"warning"}
              content={user?.pendingInvitation ? "Pending Invitation" : ""}
            />
          </HorizontalStackPanel>
        )}

        <Tabs
          activeKey={activeKey}
          onChange={({ activeKey }) => {
            setActiveKey(activeKey);
          }}
          activateOnFocus>
          <Tab title="Application assigned roles">
            {user && (
              <Block width="100%" height="100%" className={css({ position: "relative" })}>
                <AppRoles userId={user?.id} />
                <UpdateRoles userId={user?.id} />
              </Block>
            )}
          </Tab>
        </Tabs>
      </LoadingView>
    </Block>
  );
};

export default UserView;

const UpdateRoles = ({ userId }) => {
  const [css, theme] = useStyletron();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <Button
        onClick={() => {
          setIsOpen(true);
        }}
        className={css({
          position: "absolute",
          top: "-" + theme.sizing.scale400,
          right: theme.sizing.scale500,
          boxShadow: theme.lighting.shadow500,
        })}
        title="Update roles"
        size="default"
        kind="secondary"
        shape="pill">
        Update roles
      </Button>
      <UpdateRolesDialog userId={userId} isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

const AppRoles = ({ userId }) => {
  const { data, isLoading, isSuccess, error } = useGetUsersAppRolesQuery(userId);

  const items = useMemo(() => {
    return data
      ? data.slice().sort((a, b) => {
          if (
            a.displayName !== undefined &&
            a.displayName !== null &&
            b.displayName !== undefined &&
            b.displayName !== null
          )
            return a.displayName.localeCompare(b.displayName);
          return 0;
        })
      : null;
  }, [data]);
  return (
    <LoadingView isLoading={isLoading} isSucess={isSuccess} error={error}>
      {items?.map((role: TAppRoleDto) => (
        <ListItem artwork={() => <VscUnlock />} key={role.id}>
          <ListItemLabel description={role.description}>{role.displayName}</ListItemLabel>
        </ListItem>
      ))}
    </LoadingView>
  );
};
